import { render, staticRenderFns } from "./JobInsights.vue?vue&type=template&id=6c7ad974"
import script from "./JobInsights.vue?vue&type=script&lang=js"
export * from "./JobInsights.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports